<template>
  <div id="forgot-password"></div>
</template>

<script>
import eventBus from "@/shared/eventBus.js";

export default {
  data() {
    return {
      // email: "",
      // newPassword: "",
      // newPasswordConfirm: "",
      // isTokenDone: false
    };
  },
  computed: {
    tokenString() {
      return this.$route.query.token;
    }
    // formText() {
    //   return {
    //     success: this.$i18n.t("main.passwordResetSuccess"),
    //     error: this.$i18n.t("main.msgError")
    //   };
    // },
    // isValidPassword() {
    //   const isValidSize =
    //     this.newPassword.length > 7 && this.newPassword.length < 33;
    //   const isSame = this.newPassword === this.newPasswordConfirm;
    //   return isValidSize && isSame;
    // },
    // translations() {
    //   return {
    //     email: this.$i18n.t("main.email"),
    //     buttonName: this.$i18n.t("main.submit"),
    //     resetPassword: this.$i18n.t("main.resetPassword"),
    //     password: this.$i18n.t("main.password"),
    //     confirmPassword: this.$i18n.t("main.confirmPassword")
    //   };
    // }
  },
  mounted() {
    // if (this.tokenString) {
    //   this.checkValidToken();
    // }
    this.$nextTick(() => {
      this.init();
    });
  },
  activated() {
    // this.init();
  },
  methods: {
    init() {
      console.log("init ");
      let params = {
        // modalData: { userIsLoged: this.userIsLoged },
        component: "resetPasswordModal"
      };
      eventBus.$emit("openModal", params);
      // this.$router.push({
      //   name: "Home",
      //   query: { token: this.tokenString }
      // });
    }

    // async sendEmail() {
    //   if (!this.email) {
    //     return;
    //   }
    //   const params = {
    //     usr_email: this.email
    //   };
    //   try {
    //     const res = await api.forgotPassword(params);
    //     console.log("forgot password response:", res.data);
    //     this.$toast.success(this.$t("main.msgSuccess"), {
    //       duration: 3000
    //     });
    //     this.$router.push({
    //       name: "Home"
    //     });
    //   } catch (err) {
    //     this.$toast.error(this.$t("main.msgError"), {
    //       duration: 5000
    //     });
    //     console.log(err.message);
    //   } finally {
    //     this.email = "";
    //   }
    // },
    // async checkValidToken() {
    //   const params = {
    //     token: this.tokenString
    //   };
    //   try {
    //     await api.checkForgotPassword(params);
    //   } catch (err) {
    //     this.$toast.error(this.$t("errors.invalidToken"), {
    //       duration: 5000
    //     });
    //     this.$router.push({
    //       name: "Home"
    //     });
    //     console.log(err.message);
    //   }
    // },
    // async sendPassword() {
    //   if (!(this.newPassword.length > 7 && this.newPassword.length < 33)) {
    //     this.$toast.error(this.$t("errors.registration.password"), {
    //       duration: 5000
    //     });
    //     return;
    //   }
    //   if (this.newPassword !== this.newPasswordConfirm) {
    //     this.$toast.error(this.$t("errors.registration.samePasswords"), {
    //       duration: 5000
    //     });
    //     return;
    //   }
    //   const params = {
    //     token: this.tokenString,
    //     password: this.newPassword
    //   };
    //   try {
    //     await api.patchForgotPassword(params);
    //     this.isTokenDone = true;
    //   } catch (err) {
    //     this.$toast.error(this.$t("main.msgError"), {
    //       duration: 5000
    //     });
    //     console.log(err.message);
    //   } finally {
    //     this.newPassword = "";
    //     this.newPasswordConfirm = "";
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
#forgot-password {
  height: 50vh;
  min-height: 400px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .form {
    border: 1px solid silver;
    padding: 30px 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px 10px;

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding-right: 20px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      max-width: 230px;
    }

    .btn {
      background: #e9786e;
      text-transform: uppercase;
      color: white;
      width: calc(50% - 7px);
      font-weight: bold;
      font-size: 10px;
      text-transform: none;

      &.disabled {
        opacity: 0.7;
      }
    }
  }
}
</style>
